import { render, staticRenderFns } from "./pageList.vue?vue&type=template&id=47d15d87&scoped=true"
import script from "./pageList.vue?vue&type=script&lang=js"
export * from "./pageList.vue?vue&type=script&lang=js"
import style0 from "./pageList.vue?vue&type=style&index=0&id=47d15d87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d15d87",
  null
  
)

export default component.exports